// @mui
import { Box, Stack } from "@mui/material";
// config
import { NAV } from "../../../config-global";
// utils
import { hideScrollbarX } from "../../../utils/cssStyles";
// components
import Logo from "../../../components/logo";
import { NavSectionMini } from "../../../components/nav-section";
//
import navConfig from "./config-navigation";
import directorNavConfig from "./director-navigation";
import excutiveNavConfig from "./excutive-navigation";
import leadNavConfig from "./leads-navigation";
import managerNavConfig from "./manager-navigation";
import NavToggleButton from "./NavToggleButton";
import riderNavConfig from "./rider-navigation";
// routes
import { PATH_DASHBOARD } from "../../../routes/paths";
// hooks
import { useSelector } from "react-redux";
import { useAuthContext } from "../../../auth/useAuthContext";

// ----------------------------------------------------------------------

export default function NavMini() {
  const { user } = useAuthContext();

  const currentRole = user?.user?.role?.name || user?.role?.name || "Admin";

  const { categories } = useSelector((state) => state.category);

  const roleConfigMap = {
    Admin: navConfig,
    Executive: excutiveNavConfig,
    Manager: managerNavConfig,
    Leads: leadNavConfig,
    Director: directorNavConfig,
    Rider: riderNavConfig,
  };

  const selectedConfig = roleConfigMap[currentRole];

  const parentCategories =
    categories?.data?.filter((cat) => cat.parent_id === null) || [];

  const augmentedConfig = selectedConfig.map((group) => {
    if (group.subheader === "Order Management") {
      return {
        ...group,
        items: group.items.map((item) => {
          if (item.title === "Orders" || item.title === "Orders List") {
            const children = item.children
              ? [...item.children]
              : [{ title: "Orders List", path: item.path }];
            return {
              ...item,
              title: "Orders",
              path: PATH_DASHBOARD.orders.root,
              children: [
                ...parentCategories.map((cat) => ({
                  title: cat.name,
                  path: `${PATH_DASHBOARD.orders.list}?category=${cat.slug}`,
                })),
                ...children,
              ],
            };
          }
          return item;
        }),
      };
    }
    if (group.subheader === "Stock Management") {
      return {
        ...group,
        items: group.items.map((item) => {
          if (item.title === "Stock Histories") {
            const children = item.children ? [...item.children] : [];
            return {
              ...item,
              children: [
                ...parentCategories.map((cat) => ({
                  title: cat.name,
                  path: `${PATH_DASHBOARD.stockHistories}?category=${cat.slug}`,
                })),
                ...children,
              ],
            };
          }
          return item;
        }),
      };
    }
    return group;
  });

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_DASHBOARD_MINI },
      }}
    >
      <NavToggleButton
        sx={{
          top: 22,
          left: NAV.W_DASHBOARD_MINI - 12,
        }}
      />

      <Stack
        sx={{
          pb: 2,
          height: 1,
          position: "fixed",
          width: NAV.W_DASHBOARD_MINI,
          borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
          ...hideScrollbarX,
        }}
      >
        <Logo sx={{ mx: "auto", my: 2 }} />

        <NavSectionMini data={augmentedConfig} />
      </Stack>
    </Box>
  );
}
